/* eslint-disable react-hooks/rules-of-hooks */
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { Features } from '@lessonPlanner/constants';

export const logAdBlock = (data: {
  featureFlag?: Features;
  email?: string;
}): UseQueryResult<unknown> => {
  return useQuery({
    queryKey: ['logAdBlock'],
    refetchInterval: false,
    queryFn: async () => {
      const response = await fetch('/api/log-adblock', {
        method: 'POST',
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error('Failed to log adblock');
      }
      const adBlockLog = await response.json();
      return adBlockLog;
    },
  });
};
